export const ID_CATEGORIA_BELLEZZA_BENESSERE = 20;
export const ID_CATEGORIA_SPORT_DIVERTIMENTO = 22;
export const ID_CATEGORIA_RISTORAZIONE = 23;
export const ID_CATEGORIA_PROFESSIONISTI = 24;
export const ID_CATEGORIA_TURISMO = 25;
export const ID_CATEGORIA_ECOMMERCE = 26;
